import script from "./ButtonBack.vue?vue&type=script&setup=true&lang=ts"
export * from "./ButtonBack.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__